<template>
    <confirm-dialog
        v-model="shows"
        v-bind="{
            title,
            text_next,
        }"
        v-on="{
            next: emit,
            exit: sync,
        }"
    >
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <vertical-form-table v-model="form" v-bind="{ items }" />
    </confirm-dialog>
</template>

<script>
import { initLecture__LinksItem } from "@/store/lecture/lecture.inits";

import ConfirmDialog from "@/components/dumb/confirm-dialog.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import { attrs_input } from "@/assets/variables";

const items = [
    {
        key: "name",
        term: "명칭",
        type: "text",
    },
    {
        key: "href",
        term: "URL",
        type: "text",
    },
    {
        key: "isDownload",
        term: "다운로드링크",
        type: "switch",
    },
].map((item) => ({ ...attrs_input, ...item }));

export default {
    components: {
        ConfirmDialog,
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: initLecture__LinksItem },
        isCreate: { type: Boolean, default: false },
    },
    data: () => ({
        form: initLecture__LinksItem(),

        items,

        shows: false,
    }),
    computed: {
        title() {
            return `교육자료(링크) ${this.text_next}`;
        },
        text_next() {
            return this.isCreate ? "추가하기" : "수정하기";
        },
    },
    methods: {
        sync() {
            this.form = initLecture__LinksItem(this.value);
        },
        emit() {
            this.$emit("input", this.form);
            this.shows = false;
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>